import hero1 from '../assets/hero1.jpeg';
import hero2 from '../assets/hero2.jpeg';
import hero3 from '../assets/hero3.jpeg';
import hero4 from '../assets/hero4.jpeg';
import hero5 from '../assets/hero5.jpeg';
import jhangRation from '../assets/hero 3.jpg';

/* Parliament Tier Logos */
import worldParliamentLogo from '../assets/world parliament.png';
import worldStatesLogo from '../assets/world states.png';
import worldCitiesLogo from '../assets/world_cities.png';
import divisionalLogo from '../assets/divisional.png';
import districtLogo from '../assets/district.png';
import tehsilLogo from '../assets/tehsil.png';
import ucLogo from '../assets/uc.png';
import siteLogo from '../assets/logo.png';

/* Registration Form PDF */
import registrationFormPDF from '../assets/Registerartion Form.pdf';

/* Amanah Mall Existing Images */
import amanah1 from '../assets/amanah mall/amana mal 1.JPG';
import amanah2 from '../assets/amanah mall/amana mall 2.JPG';
import amanah3 from '../assets/amanah mall/amana mall 3.JPG';
import amanah4 from '../assets/amanah mall/amana mall 4.JPG';
import amanah5 from '../assets/amanah mall/amana mall 5.JPG';
import amanah6 from '../assets/amanah mall/amana mall 6.JPG';
import amanah7 from '../assets/amanah mall/amana mall 7.JPG';
import amanah13 from '../assets/amanah mall/amana mall 13.JPG';
import amanah14 from '../assets/amanah mall/amana mall 14.JPG';
import amanah15 from '../assets/amanah mall/amana mall 15.JPG';

/* Flettis Existing Images */
import flettis3 from '../assets/flettis/3.jpg';
import flettis6 from '../assets/flettis/6.jpg';
import flettis8 from '../assets/flettis/8.jpg';
import flettis9 from '../assets/flettis/IMG-20240312-WA0048.jpg';
import flettis10 from '../assets/flettis/IMG-20240312-WA0049.jpg';
import flettis11 from '../assets/flettis/IMG-20240312-WA0051.jpg';
import flettis14 from '../assets/flettis/IMG-20240312-WA0063.jpg';
import flettis15 from '../assets/flettis/IMG-20240312-WA0064.jpg';
import flettis18 from '../assets/flettis/IMG-20240312-WA0070.jpg';
import flettis19 from '../assets/flettis/IMG-20240312-WA0071.jpg';
import flettis20 from '../assets/flettis/IMG-20240312-WA0083.jpg';
import flettis21 from '../assets/flettis/IMG-20240312-WA0177.jpg';
import flettis22 from '../assets/flettis/IMG-20240312-WA0182.jpg';
import flettis23 from '../assets/flettis/IMG-20240312-WA0184.jpg';

/* Chamber of Commerce 1 Existing Images */
import chamber1_12 from '../assets/chamber of commerce 1/IMG_8550.jpg';
import chamber1_13 from '../assets/chamber of commerce 1/IMG_8551.jpg';
import chamber1_14 from '../assets/chamber of commerce 1/IMG_8574.jpg';
import chamber1_15 from '../assets/chamber of commerce 1/IMG_8601.jpg';
import chamber1_16 from '../assets/chamber of commerce 1/IMG_8603.jpg';
import chamber1_18 from '../assets/chamber of commerce 1/IMG_8646.jpg';

/* Chamber of Commerce 2 Existing Images */
import chamber2_1 from '../assets/chamber of commerce 2/IMG_9007.JPG';
import chamber2_2 from '../assets/chamber of commerce 2/IMG_9015.JPG';
import chamber2_3 from '../assets/chamber of commerce 2/IMG_9019.JPG';
import chamber2_4 from '../assets/chamber of commerce 2/IMG_9021.JPG';
import chamber2_5 from '../assets/chamber of commerce 2/IMG_9024.JPG';
import chamber2_6 from '../assets/chamber of commerce 2/IMG_9025.JPG';
import chamber2_7 from '../assets/chamber of commerce 2/IMG_9027.JPG';
import chamber2_8 from '../assets/chamber of commerce 2/IMG_9030.JPG';
import chamber2_9 from '../assets/chamber of commerce 2/IMG_9032.JPG';
import chamber2_10 from '../assets/chamber of commerce 2/IMG_9034.JPG';
import chamber2_11 from '../assets/chamber of commerce 2/IMG_9071.JPG';
import chamber2_12 from '../assets/chamber of commerce 2/IMG_9133.JPG';
import chamber2_13 from '../assets/chamber of commerce 2/IMG_9134.JPG';
import chamber2_14 from '../assets/chamber of commerce 2/IMG_9135.JPG';

/* Jhang Ration Existing Images */
import ration4_1 from '../assets/jhang rashan distribution/1.jpg';
import ration4_2 from '../assets/jhang rashan distribution/11.jpg';
import ration4_3 from '../assets/jhang rashan distribution/12.jpg';
import ration4_4 from '../assets/jhang rashan distribution/14.jpg';
import ration4_5 from '../assets/jhang rashan distribution/2.jpg';
import ration4_6 from '../assets/jhang rashan distribution/3.jpg';
import ration4_7 from '../assets/jhang rashan distribution/4.jpg';
import ration4_8 from '../assets/jhang rashan distribution/5.jpg';
import ration4_9 from '../assets/jhang rashan distribution/6.jpg';
import ration4_10 from '../assets/jhang rashan distribution/7.jpg';
import ration4_11 from '../assets/jhang rashan distribution/8.jpg';
import ration4_12 from '../assets/jhang rashan distribution/9.jpg';

/* Sialkot Existing Images */
import sialkot1 from '../assets/sialkot/2.jpg';
import sialkot2 from '../assets/sialkot/3.png';
import sialkot3 from '../assets/sialkot/4.jpg';
import sialkot4 from '../assets/sialkot/5.jpg';
import sialkot5 from '../assets/sialkot/IMG_0509.jpg';
import sialkot6 from '../assets/sialkot/IMG_0541.jpg';
import sialkot7 from '../assets/sialkot/IMG_0545.jpg';
import sialkot8 from '../assets/sialkot/IMG_0548.jpg';
import sialkot9 from '../assets/sialkot/IMG_0550.JPG';
import sialkot10 from '../assets/sialkot/IMG_0552.jpg';
import sialkot11 from '../assets/sialkot/IMG_0554.jpg';
import sialkot12 from '../assets/sialkot/IMG_0558.jpg';
import sialkot13 from '../assets/sialkot/IMG_0561.jpg';
import sialkot14 from '../assets/sialkot/IMG_0566.jpg';
import sialkot15 from '../assets/sialkot/IMG_0571.jpg';
import sialkot16 from '../assets/sialkot/IMG_0575.jpg';
import sialkot17 from '../assets/sialkot/IMG_0577.jpg';
import sialkot18 from '../assets/sialkot/IMG_0581.jpg';
import sialkot19 from '../assets/sialkot/IMG_0583.jpg';

/* Chamber of Commerce 3 Existing Images */
import chamber3_1 from '../assets/chamber of commerce 3/IMG_6829.JPG';
import chamber3_2 from '../assets/chamber of commerce 3/IMG_6832.JPG';
import chamber3_3 from '../assets/chamber of commerce 3/IMG_6840.JPG';
import chamber3_4 from '../assets/chamber of commerce 3/IMG_6869.JPG';
import chamber3_5 from '../assets/chamber of commerce 3/IMG_6874.JPG';
import chamber3_6 from '../assets/chamber of commerce 3/IMG_6899.JPG';
import chamber3_7 from '../assets/chamber of commerce 3/IMG_6902.JPG';
import chamber3_8 from '../assets/chamber of commerce 3/IMG_6904.JPG';
import chamber3_9 from '../assets/chamber of commerce 3/IMG_6919.JPG';
import chamber3_10 from '../assets/chamber of commerce 3/IMG_6923.JPG';
import chamber3_11 from '../assets/chamber of commerce 3/IMG_6927.JPG';
import chamber3_12 from '../assets/chamber of commerce 3/IMG_6930.JPG';
import chamber3_13 from '../assets/chamber of commerce 3/IMG_7004.JPG';
import chamber3_14 from '../assets/chamber of commerce 3/IMG_7007.JPG';
import chamber3_15 from '../assets/chamber of commerce 3/IMG_7212.JPG';
import chamber3_16 from '../assets/chamber of commerce 3/IMG_7250.JPG';
import chamber3_17 from '../assets/chamber of commerce 3/IMG_7257.JPG';
import chamber3_18 from '../assets/chamber of commerce 3/IMG_7263.JPG';

/* ──────────────────────────────────────────────
   ORGANIZATIONAL METADATA
   ────────────────────────────────────────────── */
export const siteInfo = {
  name: "Best Nation Welfare Organisation",
  acronym: "BNWO",
  established: 2020,
  headquarters: "Lahore, Pakistan",
  tagline: "Let's Pay Back to Pakistan",
  taglineUrdu: "بہترین قوم کی تشکیل",
  address: "60-A, Street No. 5, Model Town Link Road, G.E.C.H.S. Phase 2, Lahore",
  phone: "0321-4190008, 0321-7777011",
  email: "info@bestnationorg.com",
  registration: "Established under relevant Pakistan NGO/Welfare laws",
  hours: "Mon - Sat: 9:00 AM - 6:00 PM",
};

export const visionStatement =
  "To build a compassionate, inclusive Pakistan where every individual—regardless of background or circumstance—has equal access to the best education, healthcare, dignity, and opportunity, creating generational change through empowered families and resilient grassroots communities.";

export const missionStatement =
  "BNWO exists to translate individual compassion into collective national uplift — organizing volunteers, professionals, and community leaders into a structured network that identifies local needs, delivers targeted welfare programs, and builds accountable governance down to the Union Council level.";

export const aboutOrganization =
  "Best Nation Welfare Organisation (BNWO) Pakistan is a registered Non-Profit Organisation dedicated to human welfare, social development, and grassroots community empowerment. Established in 2020 in Lahore, BNWO operates across Pakistan through structured governance and volunteer networks.";

export const motto = "Let's Pay Back to Pakistan";

export const socialLinks = [
  { platform: "Facebook", icon: "fab fa-facebook-f", url: "https://facebook.com", label: "Facebook" },
  { platform: "Instagram", icon: "fab fa-instagram", url: "https://instagram.com", label: "Instagram" },
  { platform: "Twitter", icon: "fab fa-twitter", url: "https://twitter.com", label: "Twitter" },
  { platform: "YouTube", icon: "fab fa-youtube", url: "https://youtube.com", label: "YouTube" },
  { platform: "WhatsApp", icon: "fab fa-whatsapp", url: "https://wa.me/923214190008", label: "WhatsApp" },
];

export const focusAreas = [
  {
    id: 1,
    icon: "fas fa-graduation-cap",
    title: "Training & Education",
    description: "Capacity-building for parents, teachers, and community leaders along with literacy, skills, and Quranic/character-based development.",
  },
  {
    id: 2,
    icon: "fas fa-heartbeat",
    title: "Health Awareness & Facilities",
    description: "Preventive care, emergency services, clean water provision, and specialized treatment access for underserved communities.",
  },
  {
    id: 3,
    icon: "fas fa-briefcase",
    title: "Skills & Opportunities",
    description: "Livelihoods, empowerment, and legal protection for all segments of society through entrepreneurship and vocational training.",
  },
];

export const heroSlides = [
  {
    id: 1,
    title: "Activate Pakistan's Compassion Economy",
    description: "Join BNWO to turn local care into large-scale change with community-led food, health, and education drives.",
    btn1: { text: "Join the Mission", link: "/membership" },
    btn2: { text: "Discover Our Story", link: "/about" },
    bg: hero1,
  },
  {
    id: 2,
    title: "12 High-Impact Programs, One Purpose",
    description: "From skill training and literacy to clean water and emergency health care, our welfare programs are built for real community impact.",
    btn1: { text: "See Programs", link: "/programs" },
    btn2: { text: "How We Deliver", link: "/what-we-do" },
    bg: hero2,
  },
  {
    id: 3,
    title: "7-Tier Governance for Total Accountability",
    description: "Our unique parliament model and 24 committees ensure every project is transparent, local, and results-focused.",
    btn1: { text: "Explore Parliament", link: "/parliament" },
    btn2: { text: "Meet Committees", link: "/committees" },
    bg: hero3,
  },
  {
    id: 4,
    title: "Donate with Confidence, See Real Results",
    description: "Every fund is managed by audited field teams and delivered directly to families, clinics, and schools.",
    btn1: { text: "Donate Now", link: "/donate" },
    btn2: { text: "Track Impact", link: "/programs" },
    bg: hero4,
  },
  {
    id: 5,
    title: "Join the Movement for a Stronger Nation",
    description: "Together we create sustainable opportunity, dignity, and support for every community across Pakistan.",
    btn1: { text: "Become a Partner", link: "/membership" },
    btn2: { text: "Contact Us", link: "/contact" },
    bg: hero5,
  },
];

/* ──────────────────────────────────────────────
   12 CORE WELFARE PROGRAMS (from Concept Note)
   ────────────────────────────────────────────── */
export const corePrograms = {
  trainingEducation: [
    {
      id: 1,
      icon: "fas fa-laptop-code",
      title: "IT & Skill Institutes and Universities",
      description: "Establishing technical, vocational, and IT training institutes to equip youth with market-ready digital and technical skills.",
      bgImage: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 2,
      icon: "fas fa-book-open",
      title: "Taaleem Dost Literacy Program",
      description: "Community-based literacy drives to reduce illiteracy and enable out-of-school children and adults to access basic education.",
      bgImage: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 3,
      icon: "fas fa-quran",
      title: "Quran-o-Sunnat Awareness & Spiritual Healing Program",
      description: "Faith-based character-building and spiritual counselling rooted in Quranic teachings and Sunnah for moral and social development.",
      bgImage: "https://images.unsplash.com/photo-1609599006353-e629aaabfeae?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 4,
      icon: "fas fa-chalkboard-teacher",
      title: "Parenting & Teachers Training Program",
      description: "Capacity-building workshops for parents and teachers to strengthen child-rearing practices and classroom effectiveness.",
      bgImage: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=800&q=80",
    },
  ],
  healthFacilities: [
    {
      id: 5,
      icon: "fas fa-hand-holding-water",
      title: "Health Awareness & Clean Water Program",
      description: "Community health education, emergency ambulance response, and clean drinking water provision in underserved areas.",
      bgImage: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 6,
      icon: "fas fa-leaf",
      title: "Clean & Green Pakistan Program",
      description: "Environmental clean-up and green Pakistan tree-plantation drives and awareness campaigns.",
      bgImage: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 7,
      icon: "fas fa-procedures",
      title: "Dialysis Centers, Blood Banks & Ambulance Services",
      description: "Establishing and supporting dialysis units, blood banks, and thalassemia care centers for chronic-illness patients.",
      bgImage: "https://images.unsplash.com/photo-1584515979956-d9f6e5d09982?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 8,
      icon: "fas fa-futbol",
      title: "Best Nation Sports & Cultural Program",
      description: "Sports and cultural activities that promote physical wellbeing, healthy competition, and positive youth engagement.",
      bgImage: "https://images.unsplash.com/photo-1517649763962-0c623266010b?auto=format&fit=crop&w=800&q=80",
    },
  ],
  humanRights: [
    {
      id: 9,
      icon: "fas fa-home",
      title: "Best Nation Dar-ul-Rehmat for Orphans",
      description: "Residential and support facilities providing shelter, care, education, and upbringing for orphaned children with the addition of professional training after their matriculation.",
      bgImage: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 10,
      icon: "fas fa-tractor",
      title: "Kisan Dost Program for Livestock & Agriculture Development",
      description: "Awareness campaigns and training sessions for farmers on modern livestock management and agricultural best practices to improve productivity and rural livelihoods.",
      bgImage: "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 11,
      icon: "fas fa-fist-raised",
      title: "Youth Empowerment and Drug-free Pakistan",
      description: "Skills development, entrepreneurship support, and anti-narcotics awareness campaigns that equip young people with productive opportunities and protect them from drug abuse.",
      bgImage: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 12,
      icon: "fas fa-balance-scale",
      title: "Human Rights, Legal Support & Nikah Falah Program",
      description: "Free legal aid, human-rights advocacy, and facilitation of simple, affordable marriages (Nikah Falah) to reduce social and financial barriers.",
      bgImage: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=800&q=80",
    },
  ],
};

export const allPrograms = [
  ...corePrograms.trainingEducation,
  ...corePrograms.healthFacilities,
  ...corePrograms.humanRights,
];

export const services = allPrograms.slice(0, 6).map((p) => ({
  id: p.id,
  icon: p.icon,
  title: p.title,
  description: p.description,
  fullDescription: p.description,
  bgImage: p.bgImage,
}));

/* ──────────────────────────────────────────────
   7-TIER PARLIAMENT STRUCTURE
   ────────────────────────────────────────────── */
export const parliamentTiers = {
  international: [
    {
      id: 1,
      name: "Best Nation World Parliament",
      level: "International / National",
      minMembers: 120,
      term: "1 Year",
      mandateType: "Strategic",
      mandate: "National strategy, policy direction, international MOUs & flagship fundraising",
      logo: worldParliamentLogo,
    },
    {
      id: 2,
      name: "Best Nation World States Parliament",
      level: "State / Province",
      minMembers: 120,
      term: "1 Year",
      mandateType: "Strategic",
      mandate: "Provincial resource mobilization, strategic alignment, donor & government liaison",
      logo: worldStatesLogo,
    },
    {
      id: 3,
      name: "Best Nation World Cities Parliament",
      level: "City / Metropolitan",
      minMembers: 120,
      term: "1 Year",
      mandateType: "Strategic",
      mandate: "City-level fundraising, corporate partnerships, media & public visibility",
      logo: worldCitiesLogo,
    },
  ],
  national: [
    {
      id: 4,
      name: "Best Nation Divisional Parliament",
      level: "Divisional",
      minMembers: 240,
      term: "1 Year",
      mandateType: "Execution",
      mandate: "Divisional oversight of program execution and inter-district coordination",
      logo: divisionalLogo,
    },
    {
      id: 5,
      name: "Best Nation District Parliament",
      level: "District",
      minMembers: 240,
      term: "1 Year",
      mandateType: "Execution",
      mandate: "District-level project execution, monitoring, and committee supervision",
      logo: districtLogo,
    },
    {
      id: 6,
      name: "Best Nation Tehsil Parliament",
      level: "Tehsil",
      minMembers: 240,
      term: "1 Year",
      mandateType: "Execution",
      mandate: "Tehsil-level project delivery and local partnership building",
      logo: tehsilLogo,
    },
  ],
};

export const registrationFormUrl = registrationFormPDF;

export const allParliamentTiers = [
  ...parliamentTiers.international,
  ...parliamentTiers.national,
];

export const officeBearers = [
  { title: "Chairman / President", icon: "fas fa-crown", description: "Overall leadership and external representation" },
  { title: "Vice Chairman", icon: "fas fa-user-tie", description: "Deputizes for the Chairman and oversees internal coordination" },
  { title: "General Secretary", icon: "fas fa-file-alt", description: "Administration, records, and correspondence" },
  { title: "Finance Secretary", icon: "fas fa-coins", description: "Fund management, budgeting, and financial reporting" },
  { title: "Coordination Secretary", icon: "fas fa-network-wired", description: "Liaison with the next tier up and down the structure" },
  { title: "Committee Convenors", icon: "fas fa-users-cog", description: "Heads of the relevant thematic Project Committees" },
];

export const eligibilityCriteria = [
  "Minimum age of 25 years and a record of good moral character",
  "Demonstrated commitment to voluntary community service or relevant professional expertise",
  "No conflict of interest with BNWO's objectives or affiliated bodies",
  "Willingness to serve the full term and attend mandatory Parliament sessions and reporting cycles",
];

/* ──────────────────────────────────────────────
   24 THEMATIC WELFARE PROJECT COMMITTEES
   ────────────────────────────────────────────── */
export const projectCommittees = [
  {
    category: "Faith, Education & Training",
    icon: "fas fa-graduation-cap",
    color: "#0284C7",
    committees: [
      { id: 1, name: "Quran Sunnah Agahi Committee", bgImage: "https://images.unsplash.com/photo-1609599006353-e629aaabfeae?auto=format&fit=crop&w=800&q=80" },
      { id: 2, name: "IT & Skills Experts Committee", bgImage: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80" },
      { id: 3, name: "Literacy Experts Committee", bgImage: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800&q=80" },
      { id: 4, name: "Parents Empowerment Committee", bgImage: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=800&q=80" },
      { id: 5, name: "Teachers Empowerment Committee", bgImage: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=800&q=80" },
    ],
  },
  {
    category: "Health & Public Welfare",
    icon: "fas fa-heartbeat",
    color: "#EC4899",
    committees: [
      { id: 6, name: "Health Awareness Experts Committee", bgImage: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=800&q=80" },
      { id: 7, name: "Doctors Empowerment Committee", bgImage: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=800&q=80" },
      { id: 8, name: "Clean Water Program Committee", bgImage: "https://images.unsplash.com/photo-1541252260730-0412e8e2108e?auto=format&fit=crop&w=800&q=80" },
      { id: 9, name: "Ambulance & Blood Bank Committee", bgImage: "https://images.unsplash.com/photo-1584515979956-d9f6e5d09982?auto=format&fit=crop&w=800&q=80" },
      { id: 10, name: "Dar-ul-Rehmat Program Committee", bgImage: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80" },
    ],
  },
  {
    category: "Environment, Sports & Culture",
    icon: "fas fa-tree",
    color: "#10B981",
    committees: [
      { id: 11, name: "Drug-Free Pakistan Committee", bgImage: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=800&q=80" },
      { id: 12, name: "Clean Green Pakistan Committee", bgImage: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=800&q=80" },
      { id: 13, name: "Sports Activities Committee", bgImage: "https://images.unsplash.com/photo-1517649763962-0c623266010b?auto=format&fit=crop&w=800&q=80" },
      { id: 14, name: "Cultural Activities Committee", bgImage: "https://images.unsplash.com/photo-1469488865564-c2de10f69f96?auto=format&fit=crop&w=800&q=80" },
    ],
  },
  {
    category: "Economic & Livelihood Empowerment",
    icon: "fas fa-briefcase",
    color: "#F59E0B",
    committees: [
      { id: 15, name: "Kisan Dost / Agricultural Experts Committee", bgImage: "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?auto=format&fit=crop&w=800&q=80" },
      { id: 16, name: "SME Programs Committee", bgImage: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80" },
      { id: 17, name: "Traders Empowerment Committee", bgImage: "https://images.unsplash.com/photo-1556742049-0a67c5574f73?auto=format&fit=crop&w=800&q=80" },
      { id: 18, name: "Industrialist Empowerment Committee", bgImage: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80" },
      { id: 19, name: "Youth Empowerment Committee", bgImage: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80" },
      { id: 20, name: "Women Empowerment Committee", bgImage: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80" },
    ],
  },
  {
    category: "Legal, Rights & Public Services",
    icon: "fas fa-balance-scale",
    color: "#8B5CF6",
    committees: [
      { id: 21, name: "Nikah Falah Program Committee", bgImage: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=800&q=80" },
      { id: 22, name: "Rules of Law Implementation Committee", bgImage: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=800&q=80" },
      { id: 23, name: "Lawyers Legal Support Committee", bgImage: "https://images.unsplash.com/photo-1453728013993-6d66e9c9123a?auto=format&fit=crop&w=800&q=80" },
      { id: 24, name: "Public Basic Needs Relief Committee", bgImage: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?auto=format&fit=crop&w=800&q=80" },
    ],
  },
];

export const allCommitteesList = projectCommittees.flatMap((c) =>
  c.committees.map((item) => ({ ...item, category: c.category, icon: c.icon }))
);

export const membershipTiers = [
  {
    id: 1,
    tier: "World Parliament",
    role: "Member",
    fee: "$300",
    currency: "USD",
    contribution: "National strategy, MOUs & flagship fundraising",
    level: "international",
  },
  {
    id: 2,
    tier: "World States Parliament",
    role: "Member",
    fee: "$200",
    currency: "USD",
    contribution: "Provincial fundraising & strategic alignment",
    level: "international",
  },
  {
    id: 3,
    tier: "World Cities Parliament",
    role: "Member",
    fee: "$100",
    currency: "USD",
    contribution: "City-level fundraising & partnerships",
    level: "international",
  },
  {
    id: 4,
    tier: "Divisional Parliament",
    role: "Member",
    fee: "PKR 5,000",
    currency: "PKR",
    contribution: "Divisional execution oversight",
    level: "national",
  },
  {
    id: 5,
    tier: "District Parliament",
    role: "Member",
    fee: "PKR 5,000",
    currency: "PKR",
    contribution: "District project execution & monitoring",
    level: "national",
  },
  {
    id: 6,
    tier: "Tehsil Parliament",
    role: "Member",
    fee: "PKR 5,000",
    currency: "PKR",
    contribution: "Tehsil-level project delivery",
    level: "national",
  },
];

export const accountabilityChain = [
  {
    step: 1,
    title: "International Parliaments",
    subtitle: "Strategy & Fundraising",
    logos: [worldParliamentLogo],
    icon: "fas fa-globe",
  },
  {
    step: 2,
    title: "Local Parliaments",
    subtitle: "Oversight & Coordination",
    logos: [divisionalLogo, districtLogo, tehsilLogo],
    icon: "fas fa-landmark",
  },
  {
    step: 3,
    title: "Project Committees",
    subtitle: "Day-to-Day Execution",
    logos: [siteLogo],
    icon: "fas fa-tasks",
  },
  {
    step: 4,
    title: "Communities & Beneficiaries",
    subtitle: "Impact & Outreach",
    icon: "fas fa-users",
  },
];

export const stats = [
  { id: "stat1", icon: "fas fa-users", target: 12000, label: "Lives Reached" },
  { id: "stat2", icon: "fas fa-project-diagram", target: 12, label: "Core Welfare Programs" },
  { id: "stat3", icon: "fas fa-landmark", target: 7, label: "Parliament Tiers" },
  { id: "stat4", icon: "fas fa-tasks", target: 24, label: "Project Committees" },
];

export const eventsData = [
  {
    id: 1,
    title: "Chamber of Commerce Lahore",
    date: "February 24, 2026",
    time: "11:00 AM - 3:00 PM",
    location: "Lahore Chamber of Commerce & Industry, Lahore",
    description:
      "BNWO joined leaders and members at the Lahore Chamber of Commerce for dialogue on community welfare, partnerships, and how the business community can support outreach and social impact initiatives.",
    image: chamber1_12,
    gallery: [
      chamber1_12,
      chamber1_13,
      chamber1_14,
      chamber1_15,
      chamber1_16,
      chamber1_18,
    ],
    status: "past",
  },
  {
    id: 6,
    title: "Chamber of Commerce Meeting",
    date: "March 5, 2026",
    time: "10:00 AM - 2:00 PM",
    location: "Chamber of Commerce, Lahore",
    description:
      "BNWO representatives met with Chamber of Commerce members to discuss corporate social responsibility, community welfare partnerships, and opportunities for businesses to support outreach and training programs.",
    image: chamber2_1,
    gallery: [
      chamber2_1,
      chamber2_2,
      chamber2_3,
      chamber2_4,
      chamber2_5,
      chamber2_6,
      chamber2_7,
      chamber2_8,
      chamber2_9,
      chamber2_10,
      chamber2_11,
      chamber2_12,
      chamber2_13,
      chamber2_14,
    ],
    status: "past",
  },
  {
    id: 7,
    title: "Chamber of Commerce Partnership Forum",
    date: "April 10, 2026",
    time: "11:00 AM - 3:00 PM",
    location: "Chamber of Commerce, Lahore",
    description:
      "A follow-up Chamber of Commerce forum focused on long-term collaboration between BNWO and the business community, with plans for joint welfare drives, skills initiatives, and sustained support for underserved families.",
    image: chamber3_1,
    gallery: [
      chamber3_1,
      chamber3_2,
      chamber3_3,
      chamber3_4,
      chamber3_5,
      chamber3_6,
      chamber3_7,
      chamber3_8,
      chamber3_9,
      chamber3_10,
      chamber3_11,
      chamber3_12,
      chamber3_13,
      chamber3_14,
      chamber3_15,
      chamber3_16,
      chamber3_17,
      chamber3_18,
    ],
    status: "past",
  },
  {
    id: 2,
    title: "Jhang Ration Distribution",
    date: "October 12, 2025",
    time: "10:00 AM - 4:00 PM",
    location: "Jhang, Punjab",
    description:
      "Ration packs and essential groceries were distributed to families in need across Jhang, with volunteers coordinating registration, packing, and handover so support reached those who needed it most.",
    image: jhangRation,
    gallery: [
      ration4_1,
      ration4_5,
      ration4_6,
      ration4_7,
      ration4_8,
      ration4_9,
      ration4_10,
      ration4_11,
      ration4_12,
      ration4_2,
      ration4_3,
      ration4_4,
    ],
    status: "past",
  },
  {
    id: 5,
    title: "Flattis Lahore Welfare Event",
    date: "January 18, 2026",
    time: "12:00 PM - 5:00 PM",
    location: "Flattis, Lahore",
    description:
      "BNWO organized a welfare and networking event at Flattis Lahore, highlighting community development goals, volunteer engagement, and partnerships to expand education and social support services.",
    image: flettis3,
    gallery: [
      flettis3,
      flettis6,
      flettis8,
      flettis9,
      flettis10,
      flettis11,
      flettis14,
      flettis15,
      flettis18,
      flettis19,
      flettis20,
      flettis21,
      flettis22,
      flettis23,
    ],
    status: "past",
  },
  {
    id: 4,
    title: "Sialkot Community Function",
    date: "November 20, 2025",
    time: "11:00 AM - 4:00 PM",
    location: "Sialkot, Punjab",
    description:
      "A community gathering in Sialkot brought together local supporters, volunteers, and partners to celebrate BNWO's welfare work and strengthen collaboration for skills training and family support programs.",
    image: sialkot1,
    gallery: [
      sialkot1,
      sialkot2,
      sialkot3,
      sialkot4,
      sialkot5,
      sialkot6,
      sialkot7,
      sialkot8,
      sialkot9,
      sialkot10,
      sialkot11,
      sialkot12,
      sialkot13,
      sialkot14,
      sialkot15,
      sialkot16,
      sialkot17,
      sialkot18,
      sialkot19,
    ],
    status: "past",
  },
  {
    id: 3,
    title: "Amanah Mall Community Drive",
    date: "December 8, 2025",
    time: "2:00 PM - 6:00 PM",
    location: "Amanah Mall, Lahore",
    description:
      "BNWO held a community awareness and welfare drive at Amanah Mall, connecting with families, sharing information about our programs, and building support for education and outreach initiatives across Lahore.",
    fullDescription:
      "The Amanah Mall Community Drive brought together BNWO volunteers, partner organizations, and local families for a full day of awareness and engagement. Our teams guided visitors about ongoing welfare projects, youth skill-building programs, education support, and how communities can directly participate in social impact activities. The event also featured one-on-one interactions with families to understand their needs and improve future support planning.",
    image: amanah1,
    gallery: [
      amanah1,
      amanah2,
      amanah3,
      amanah4,
      amanah5,
      amanah6,
      amanah7,
      amanah13,
      amanah14,
      amanah15,
    ],
    status: "past",
  },
];

export const partners = [
  { id: 1, name: "PayPro", logo: "PayPro" },
  { id: 2, name: "Faysal Bank", logo: "Faysal" },
  { id: 3, name: "U Bank", logo: "U Bank" },
  { id: 4, name: "JazzCash", logo: "JazzCash" },
  { id: 5, name: "EasyPaisa", logo: "EasyPaisa" },
  { id: 6, name: "NayaPay", logo: "NayaPay" },
];